import { render, staticRenderFns } from "./AxAxureLogo.vue?vue&type=template&id=6baa7270&"
import script from "./AxAxureLogo.vue?vue&type=script&lang=ts&"
export * from "./AxAxureLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports